import { render } from "./ServiceDetailView.vue?vue&type=template&id=7627816a&scoped=true"
import script from "./ServiceDetailView.vue?vue&type=script&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&lang=js"

import "./ServiceDetailView.vue?vue&type=style&index=0&id=7627816a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7627816a"]])

export default __exports__